import baseApi from '@/store/api/baseApi';

export const supplierConfigurationApiSlice = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		createDevelopedProduct: builder.mutation({
			query: ({ body, id, subCategoryId }) => ({
				url: `supplier/${id}/add-manufactured-designs?subCategoryId=${subCategoryId}`,
				method: 'POST',
				body
			})
		}),
		getManufacturedDesigns: builder.query({
			query: (id) => ({
				url: `supplier/${id}/manufactured-designs`,
				method: 'GET'
			})
		}),
		getSubCategoryWiseManufacturedDesigns: builder.query({
			query: ({ id, subCategoryId }) => ({
				url: `supplier/${id}/manufactured-designs-by-sub-category?subCategoryId=${subCategoryId}`,
				method: 'GET'
			})
		})
	})
});

export const {
	useCreateDevelopedProductMutation,
	useGetManufacturedDesignsQuery,
	useGetSubCategoryWiseManufacturedDesignsQuery
} = supplierConfigurationApiSlice;
